import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">小蓝视频</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              轻量、高清、流畅的短视频平台。<br />
              让碎片时间更有趣、更有价值。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">首页</Link></li>
              <li><Link to="/category/gaoxiao" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">分类浏览</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/gaoxiao" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">搞笑</Link></li>
              <li><Link to="/category/meishi" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">美食</Link></li>
              <li><Link to="/category/zhishi" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">知识</Link></li>
              <li><Link to="/category/shenghuo" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">生活</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-base"></i>
                support@xiaolanvideo.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line text-base"></i>
                400-888-6666
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line text-base"></i>
                深圳市南山区科技园
              </li>
            </ul>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-10 pt-8 border-t border-background-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2024-2026 小蓝视频 版权所有 | 粤ICP备2024XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors duration-200 cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors duration-200 cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors duration-200 cursor-pointer" aria-label="抖音">
              <i className="ri-tiktok-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}